import type { NamespaceSchema } from './types';

export const paymentSettings: NamespaceSchema = {
  namespace: 'payment-settings',
  label: 'Payment',
  description: 'Stripe + manual-payment configuration. Real keys stay in AWS Secrets Manager — these fields toggle behaviour, not credentials.',
  sections: [
    {
      label: 'Stripe',
      description: 'Stripe API keys live in env (STRIPE_SECRET_KEY, NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY) — set those at deploy time, not here.',
      fields: [
        {
          kind: 'select',
          key: 'stripe_mode',
          label: 'Stripe mode',
          default: 'test',
          description: 'Switches which key prefix the API resolves at request time.',
          options: [
            { value: 'test', label: 'Test (sandbox keys)' },
            { value: 'live', label: 'Live (production keys)' },
          ],
        },
        { kind: 'boolean', key: 'stripe_enabled', label: 'Stripe enabled', description: 'Off = checkout falls back to manual offline only.', default: true },
      ],
    },
    {
      label: 'Booking deposits',
      fields: [
        { kind: 'boolean', key: 'deposit_enabled', label: 'Require a deposit at checkout', default: false },
        { kind: 'select', key: 'deposit_type', label: 'Deposit type', default: 'percent', options: [
          { value: 'percent', label: 'Percent of total' },
          { value: 'fixed', label: 'Fixed amount (primary currency)' },
        ] },
        { kind: 'number', key: 'deposit_amount', label: 'Deposit amount', min: 0, description: 'Percentage 0-100 or fixed in primary currency.' },
      ],
    },
    {
      label: 'Walk-in charges',
      description: 'Street hails: a passenger flags a driver down and pays by link. Priced separately from bookings.',
      fields: [
        {
          kind: 'number',
          key: 'walk_in_commission_percent',
          label: 'DriveCars commission (%)',
          min: 0,
          max: 100,
          default: 0,
          description: 'Share of the captured fare DriveCars keeps. Applied when the driver settles, to the amount actually captured. 0 = the driver keeps the whole fare. Changing it never re-prices charges already settled.',
        },
      ],
    },
    {
      label: 'Buyer fees',
      fields: [
        { kind: 'boolean', key: 'buyer_fees_enabled', label: 'Show buyer fees on cart', default: false },
        { kind: 'select', key: 'buyer_fees_type', label: 'Buyer fee type', default: 'percent', options: [
          { value: 'percent', label: 'Percent of subtotal' },
          { value: 'fixed', label: 'Fixed amount per booking' },
        ] },
        { kind: 'number', key: 'buyer_fees_amount', label: 'Buyer fee amount', min: 0 },
      ],
    },
  ],
};
